<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
                    <a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getNotificheAll()">Template</a> 
					<span class="hidden-xs ms-1">\</span> 
					<span class="text-muted ms-1">Gestione Notifiche</span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">
					
					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-if="$root.hasFunzionalita('NOTIFICHE_CREATE')" v-on:click="nuovaTipologiaNotifica()">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_NUOVO'"></Translate> Tipologia Notifica
							</div>
							<div class="text-success fw-semibold">Aggiungi</div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(this.modulo)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(this.modulo)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7" style="color: orange;"></i>
						</a>
	                </div>
				</div>
			</div>
		</div> 
		<!-- /breadcrumb -->

        <!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#config-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="icon-menu7"></i>
								<span class="hidden-lg ms-1">Notifiche</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Notifiche</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>  

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><i class="ph-gear me-1"></i><span style="font-size:0.8rem;">Azioni Multiple</span></a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Pagina corrente</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Notifiche selezionate</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Tutti le Notifiche</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina Notifiche</a>
								</div>
							</div>
						</li>
						<li class="nav-item">					

						</li>
					</ul>
			   </div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->
	
	<!-- Content area -->
	<div class="content content-1 table-cms-wrapper">
        <div class="tab-content flex-1 order-2 order-lg-1">

            <div class="tab-pane fade active show" id="config-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								VEDI FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="utente-a">
									<div class="row">
										<div class="col-6 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Id Notifica" v-model="search.ID_TIPOLOGIA_NOTIFICA.VALUE" :tabindex="7" />
										</div>
										<div class="col-6 col-md-1 col-lg-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Titolo" v-model="search.TITOLO.VALUE" :tabindex="7" />
										</div>
										<div class="col-6 col-md-1 col-lg-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Descrizione" v-model="search.DESCRIZIONE.VALUE" :tabindex="7" />
										</div>
										<div class="col-6 col-md-2 col-lg-2 mbx-1">
											<select class="form-select form-select-sm" v-model="search.FK_ID_MODULO.VALUE">
												<option value="">Modulo</option>
												<option v-for="modulo in $root.arrayTipoModuli" v-bind:value="modulo.ID_OPZIONE_TIPOLOGICA" v-bind:key="modulo.ID_OPZIONE_TIPOLOGICA"> &nbsp; {{ modulo.DESCRIZIONE }}</option>
											</select>
										</div>
										<div class="col-12 col-md-5 col-lg-3">
											
										</div>
										<div class="col-6 col-md-1 col-lg-1">
											<select class="form-select form-select-sm" data-placeholder="Stato" v-model="search.FLG_ATTIVO.VALUE" :tabindex="13">
												<option value="">Tutti </option>   
												<option value="1"> &nbsp; Attive</option>
												<option value="0"> &nbsp; Non Attive</option>
											</select>
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a href="#" class="btn btn-flat-info btn-sm w-100 collapsed" role="button" aria-expanded="false">
			                                    &nbsp;
											</a>
										</div>
									</div>		
								</form>
							</div>
						</div> 
					</div>
				
			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:2%;"> <input id="chkAllNotifiche" v-on:click="filters.selectAll('chkAllNotifiche',paginatedList.arr)" type="checkbox" class=""> </th>
										<th class="table-head-sm" style="width:6%;"> #<br /><span class="float-end"> </span></th>
										<th class="table-head-sm">Titolo<br />Descrizione</th>
										<th class="table-head-sm" style="width:17%;">Modulo
										</th>
										<th class="table-head-sm text-center" style="width:5%;">Stato</th>
										<th class="table-head-sm text-center" style="width:5%;">Azioni</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="tipoNotifica in paginatedList.arr" v-bind:key="tipoNotifica.ID_TIPOLOGIA_NOTIFICA">
										<td class="td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="tipoNotifica.SELEZIONATO" class=""> 
										</td>
										<td class="td-class fs-sm">
											<span>{{tipoNotifica.ID_TIPOLOGIA_NOTIFICA}}</span><br />
											<small class="badge bg-light text-primary float-end"> &nbsp; </small>
										</td>
										<td class="td-class fs-sm">
											<span class="text-primary text-uppercase fw-bold cursor-pointer">{{tipoNotifica.TITOLO}}</span><br />
											<span class="text-dark">{{ tipoNotifica.DESCRIZIONE }}</span>
										</td>
										<td class="td-class fs-sm">
											{{ getLangModulo(tipoNotifica.FK_ID_MODULO) }}
										</td>  
										<td class="td-class text-center">
											<ISwitch @toggle="updateStatoNotifica(tipoNotifica)" v-model="tipoNotifica.FLG_ATTIVO" :size="'sm'" style="z-index: 0;"></ISwitch>
										</td>
										<td class="td-class text-center">
											<div class="dropdown">
												<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
													<i class="ph-list"></i>
												</a>
												<div class="dropdown-menu dropdown-menu-end">
													<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('NOTIFICHE_UPDATE')" v-on:click="modificaTipologiaNotifica(tipoNotifica)"><i class="fad fa-pencil fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica Menu</a>
													<div class="dropdown-divider"></div>
													<a href="#" class="dropdown-item" v-if="$root.hasFunzionalita('NOTIFICHE_DELETE')" v-on:click="eliminaTipologiaNotifica(tipoNotifica)"><i class="fad fa-trash fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina Menu</a>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2">RISULTATI: {{ paginatedList.count }}</span>
                            	</div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
			                        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
			                    </div>
			                </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
			            	</div>
			        	</div>
					</div>
				</div>
            </div>

		</div>
	</div>

		
	<!-- START MODALI -->
	<div class="modal fade" id="popUpTipologicaNotifica" tabindex="-1"  role="dialog"  >
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header bg-secondary text-white">
					<h6 class="modal-title">Tipologica Notifica</h6>
					<button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
				</div>
				<div class="modal-body">
					<div class="form-group">
						<label>Titolo</label>
						<input type="text" class="form-control"  placeholder="Descrizione" v-model="notificaTipologiaSelezionata.TITOLO">
					</div>
					<div class="form-group">
						<label>Descrizione</label>
						<input type="text" class="form-control"  placeholder="Descrizione" v-model="notificaTipologiaSelezionata.DESCRIZIONE">
					</div>
					<div class="row">
						<div class="col-md-6">
							<div class="form-group">
								<label>Modulo</label>
								<select class="form-control" v-model="notificaTipologiaSelezionata.FK_ID_MODULO" placeholder="Modulo">
									<option value="" selected>Seleziona</option>
									<option v-for="modulo in $root.arrayTipoModuli" v-bind:value="modulo.ID_OPZIONE_TIPOLOGICA" v-bind:key="modulo.ID_OPZIONE_TIPOLOGICA"> {{ modulo.CUSTOM_1 }} </option>
								</select>
							</div>                               
						</div>
						<div class="col-md-6">
							<div class="form-group">
								<label>Stato</label>
								<select class="form-control" v-model="notificaTipologiaSelezionata.FLG_ATTIVO">
									<option v-bind:value="0">NON ATTIVO</option>
									<option v-bind:value="1">ATTIVO</option>
								</select>
							</div>                               
						</div>
					</div>

				</div>	
				<div class="modal-footer modal-footer-1 bg-light">
					<button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw"></i> CHIUDI</button>
					<button class="btn btn-success float-end btn-sm" v-if="$root.hasFunzionalita('NOTIFICHE_CREATE') || $root.hasFunzionalita('NOTIFICHE_UPDATE')" v-on:click="salvaTipologicaNotifica(notificaTipologiaSelezionata)"><i class="fal fa-save fa-fw"></i> SALVA</button>                                   
				</div>
			</div>
		</div>
	</div>


</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISwitch from '@/components/utils/ISwitch.vue'
//import SelectLingue  from '@/components/utils/SelectLingue.vue'

export default {
    name:"ConfTravelNotifiche",		

    components:{
        Pagine,
        ISwitch,
		//SelectLingue 
    
    },

    data: function () {
        return {   
            apiStartup:'shared/notifiche/allutente',
			filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
            arrayTipologieNotifiche : new Array(),
			search:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
	          	ID_TIPOLOGIA_NOTIFICA:{TYPE:'TEXT',VALUE:''},
				TITOLO:{TYPE:'TEXT',VALUE:''},
				DESCRIZIONE:{TYPE:'TEXT',VALUE:''},
				FLG_ATTIVO:{TYPE:'COMBO',VALUE:'1'},	 
                FK_ID_MODULO:{TYPE:'COMBO',VALUE:''},
                
            },
			notificaTipologiaSelezionata : {},
            currentLang:0,
        }
		
    },

    methods: {
        getTipologieNotifiche: function () {
            utils.get("shared/notifiche/tipologie",{}, (response) => {
                this.arrayTipologieNotifiche = response.data;
				this.search.FLG_ATTIVO.VALUE = '1'
            });
        },

		nuovaTipologiaNotifica : function(){
            this.notificaTipologiaSelezionata = utils.nuovoElemento(this.notificaTipologiaSelezionata,{ID_TIPOLOGIA_NOTIFICA:0},"popUpTipologicaNotifica");
		},

		modificaTipologiaNotifica : function(tipologiaNotifica){
            this.notificaTipologiaSelezionata = utils.clone(tipologiaNotifica);
			this.filters.openPopUp('popUpTipologicaNotifica');
		},

		eliminaTipologiaNotifica : function (tipologiaNotifica){
			utils.alert.confirm("Sei sicuro di voler eliminare questo incasso?",()=>{
				utils.delete("shared/notifiche/tipologica/delete",tipologiaNotifica, (response) => {
					if (response.esito == 0){
						utils.alert.success(response.messaggio);
						this.getTipologieNotifiche();
					}
				});
            },this.$root);
		},

        updateStatoNotifica : function(tipoNotifica){
            setTimeout(() => {
                utils.put('shared/notifiche/tipologica/update',tipoNotifica, (response) => {
                    if (response.esito == 0){
                        utils.alert.success(response.messaggio);
						this.getTipologieNotifiche();
                    }  
                }); 
            },250);
        },

		salvaTipologicaNotifica : function(notificaTipologiaSelezionata){
			var api = notificaTipologiaSelezionata.ID_TIPOLOGIA_NOTIFICA == 0  ? "shared/notifiche/tipologica/insert" : "shared/notifiche/tipologica/update";
			utils.ajax(api,notificaTipologiaSelezionata, (response) => {
				if (response.esito == 0){
                    utils.alert.success(response.messaggio);
					this.filters.closePopUp('popUpTipologicaNotifica');
                    this.getTipologieNotifiche();
                }
            });
		},

		getLangModulo : function(idModulo){
			var modulo = utils.array.select(this.$root.arrayTipoModuli,"ID_OPZIONE_TIPOLOGICA",idModulo,1)[0];
			return modulo ? modulo.DESCRIZIONE : '';
		},



    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayTipologieNotifiche,this.search);
            return arr;
        }

    },

    created: function () {
        this.getTipologieNotifiche();
    },

}
</script>
